import request from '@/utils/request'

// 查询问卷用户答题明细列表
export function listSurveyDetailUser(query) {
    return request({
        url: '/biz/surveyDetailUser/list',
        method: 'get',
        params: query
    })
}

// 查询问卷用户答题明细详细
export function getSurveyDetailUser(id) {
    return request({
        url: '/biz/surveyDetailUser/' + id,
        method: 'get'
    })
}

// 新增问卷用户答题明细
export function addSurveyDetailUser(data) {
    return request({
        url: '/biz/surveyDetailUser',
        method: 'post',
        data: data
    })
}

// 修改问卷用户答题明细
export function updateSurveyDetailUser(data) {
    return request({
        url: '/biz/surveyDetailUser/update',
        method: 'post',
        data: data
    })
}

// 删除问卷用户答题明细
export function delSurveyDetailUser(id) {
    return request({
        url: '/biz/surveyDetailUser/delete/' + id,
        method: 'post'
    })
}
